const AllTaskBoard = () => import("./views/AllTaskBoard.vue");
const ViewTaskBoard = () => import("./views/ViewTaskBoard.vue");

export default [
  {
    path: "task-board",
    component: AllTaskBoard,
  },
  {
    path: "view-task-board/:id",
    component: ViewTaskBoard,
  },
];
